document.addEventListener('DOMContentLoaded', () => {
  const UPSELL_VARIANT_ID = 45976917836011; // Replace with actual variant ID of upsell product
  let upsellEnabled = true;

  window.toggleUpsell = function(enable) {
    upsellEnabled = enable;
    console.log(`[Upsell] Function ${enable ? 'enabled' : 'disabled'}`);

    if (!enable) {
      // Remove upsell items when disabled
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const upsellItems = cart.items.filter(item => item.variant_id === UPSELL_VARIANT_ID);
          return Promise.all(
            upsellItems.map(item => 
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              })
            )
          );
        })
        .then(() => {
          if (window.updateCart) window.updateCart();
        });
    } else {
      // Add upsell item when enabled
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const existingUpsellItem = cart.items.find(item => item.variant_id === UPSELL_VARIANT_ID);
          
          if (!existingUpsellItem) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: UPSELL_VARIANT_ID, quantity: 1 })
            });
          }
        })
        .then(() => {
          if (window.updateCart) window.updateCart();
        });
    }
  };

  function addUpsellItemToCart() {
    if (!upsellEnabled) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const existingUpsellItem = cart.items.find(item => item.variant_id === UPSELL_VARIANT_ID);
        
        if (!existingUpsellItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: UPSELL_VARIANT_ID, quantity: 1 })
          });
        }
      });
  }

  document.querySelectorAll('form[action="/cart.js"]').forEach(form => {
    form.addEventListener('submit', addUpsellItemToCart);
  });
});